module.exports = __webpack_public_path__ + "static/vf_wdressshoes_core.5917ac56.svg";